import { render, staticRenderFns } from "./CityshuaMc.vue?vue&type=template&id=918f422c&scoped=true"
import script from "./CityshuaMc.vue?vue&type=script&lang=js"
export * from "./CityshuaMc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "918f422c",
  null
  
)

export default component.exports